var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Storage } from './Storage';
var TokenStorage = (function (_super) {
    __extends(TokenStorage, _super);
    function TokenStorage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TokenStorage.isSupported = function () {
        return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
    };
    TokenStorage.prototype.getAccessToken = function () {
        return window.localStorage.getItem(this.accessTokenName) || '';
    };
    TokenStorage.prototype.getRefreshToken = function () {
        return window.localStorage.getItem(this.refreshTokenName) || '';
    };
    TokenStorage.prototype.setRefreshToken = function (refreshToken) {
        window.localStorage.setItem(this.refreshTokenName, refreshToken);
    };
    TokenStorage.prototype.setAccessToken = function (accessToken) {
        window.localStorage.setItem(this.accessTokenName, accessToken);
    };
    TokenStorage.prototype.setItem = function (item, value) {
        window.localStorage.setItem(item, value);
    };
    TokenStorage.prototype.removeItem = function (item) {
        window.localStorage.removeItem(item);
    };
    TokenStorage.prototype.getItem = function (key) {
        return window.localStorage.getItem(key);
    };
    TokenStorage.prototype.removeTokens = function () {
        window.localStorage.removeItem(this.refreshTokenName);
        window.localStorage.removeItem(this.accessTokenName);
    };
    return TokenStorage;
}(Storage));
export { TokenStorage };
//# sourceMappingURL=TokenStorage.js.map